// extracted by mini-css-extract-plugin
module.exports = {"bgcolor":"VodFooter_bgcolor__xJEk_","headerSize":"VodFooter_headerSize__3ka6F"};